var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ib-loader-overlay-wrapper",class:{'cursor-not-allowed': _vm.hideLoader}},[(!_vm.hideLoader)?_c('div',{staticClass:"lds-roller"},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }